export enum SocialsProvider {
  Instagram = 'instagram',
  Facebook = 'facebook',
  Linkedin = 'linkedin',
}
